import { Images } from 'assets/images';
import {
  PackageImage,
  PackageMainInfo,
  PackageTitle,
  PackagePrice,
  TitleAndPriceBlock,
  ViewPackageWrapper,
  PackageInfo,
  PackageDescription,
  DescriptionParagraph,
  LinkToUrl,
  CloseIcon,
} from 'admin/components/Offer/styled';

export const ViewPackage = ({ viewData, closeModal }) => (
  <ViewPackageWrapper>
    <PackageMainInfo>
      <TitleAndPriceBlock>
        <PackageTitle>{viewData.title}</PackageTitle>
        <PackagePrice>{viewData.price}</PackagePrice>
      </TitleAndPriceBlock>
      <PackageImage image={viewData.image} />
      <CloseIcon src={Images.closeBlueIcon} onClick={closeModal} />
    </PackageMainInfo>

    <PackageInfo>
      <PackageDescription>
        Description:
        <DescriptionParagraph> {viewData.description}</DescriptionParagraph>
      </PackageDescription>
      <PackageDescription>
        Country, city:
        <DescriptionParagraph> {viewData.country_city}</DescriptionParagraph>
      </PackageDescription>
      <PackageDescription>
        Stay:
        <DescriptionParagraph> {viewData.stay}</DescriptionParagraph>
      </PackageDescription>
      <PackageDescription>
        Population:
        <DescriptionParagraph> {viewData.population}</DescriptionParagraph>
      </PackageDescription>
      <PackageDescription>
        Language:
        <DescriptionParagraph> {viewData.language}</DescriptionParagraph>
      </PackageDescription>
      <PackageDescription>
        Booking Url:
        <LinkToUrl href={`${viewData.booking_url}`} target="_blank" rel="noreferrer">
          {` ${viewData.booking_url}`}
        </LinkToUrl>
      </PackageDescription>
      <PackageDescription>
        Ticket Url:
        <LinkToUrl href={`${viewData.ticket_url}`} target="_blank" rel="noreferrer">
          {viewData.ticket_url}
        </LinkToUrl>
      </PackageDescription>
    </PackageInfo>
  </ViewPackageWrapper>
);
